import React from "react";
import { InfoTimeCardAdv, PageHeader, PageTitle, TableAdv } from "../../../../../components";
import { PlacementDetailsRows } from "../../../../../assets/data/candidatesData";
import { mapTableRows } from "../../../../../utils";


const PlacementDetailsColumns = [
  { key: "date", label: "Date" },
  { key: "Transaction", label: " Transaction" },
  { key: "Description", label: "Description" },
  { key: "Type", label: "Type" },
  { key: "TransactionAmount", label: "Transaction Amount" },
  { key: "Payrate", label: "Pay rate" },
];



// const tableData = PlacementDetailsRows
const tableData = []
const mappedRows = mapTableRows(tableData, PlacementDetailsColumns);



const Creditbalancedashboard = () => {
  return (
    <div className="px-3 py-2">
      <div className="mt-2 ">
        <PageHeader
          Section={
            <div className="flex mb-3">
              <PageTitle title={"Placement Details"} tag="h6" />
            </div>
          }
        />
        <div className="grid grid-cols-5 gap-x-8 gap-y-6 max-w-9xl mb-10 ">
          <InfoTimeCardAdv
            title="Amount Used"
            // value="12768.00"
            value="0"
            // prefix="$"
            suffix="USD"
            variant={"contained"}
            color={"primary"}
            type={"type2"}
          />
        </div>
        <div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-5">
            <div className="bg-white shadow-sm border border-gray-300 p-4 rounded-xl">
              <div className="w-12 h-12 rounded-full bg-[var(--color-primary-100)] flex items-center justify-center">
                <span className="material-symbols-outlined text-[var(--color-primary-500)]">
                  local_atm
                </span>
              </div>
              <div className="flex justify-between w-full mt-2">
                <span>Total TS Invoiced</span>
                {/* <span className="font-semibold">$ 1,593,461.42</span> */}
                <span className="font-semibold">-</span>
              </div>
              <div className="flex justify-between w-full mt-2">
                <span>Total TS Invoice Payments Received()</span>
                {/* <span className="font-semibold">$ 852366.06</span> */}
                <span className="font-semibold">-</span>
              </div>
              <div className="flex justify-between w-full mt-2">
                <span>Total TS Invoice Payments Balance</span>
                {/* <span className="font-semibold">$ 741095.36</span> */}
                <span className="font-semibold">-</span>
              </div>
            </div>
            <div className="bg-white shadow-sm border border-gray-300 p-4 rounded-xl">
              <div className="w-12 h-12 rounded-full bg-[var(--color-primary-100)] flex items-center justify-center">
                <span className="material-symbols-outlined text-[var(--color-primary-500)]">
                  local_atm
                </span>
              </div>
              <div className="flex justify-between w-full mt-2">
                <span>Total TS Invoiced(Pay Rate)</span>
                {/* <span className="font-semibold">$ 1,593,461.42</span> */}
                <span className="font-semibold">-</span>
              </div>
              <div className="flex justify-between w-full mt-2">
                <span>Total TS Invoice Payments Received(Pay Rate)</span>
                {/* <span className="font-semibold">$ 852366.06</span> */}
                <span className="font-semibold">-</span>
              </div>
              <div className="flex justify-between w-full mt-2">
                <span>Total TS Invoice Payments Balance(Pay Rate)</span>
                {/* <span className="font-semibold">$ 741095.36</span> */}
                <span className="font-semibold">-</span>
              </div>
            </div>
          </div>
        </div>
        <TableAdv
          tableId={`employee_payments_creditbalanceddashboard`}
          columns={PlacementDetailsColumns}
          rows={mappedRows}
          hideToolBar
        />
      </div>
    </div>
  );
};

export default Creditbalancedashboard;
